import { Loader } from 'rsuite';

export default function BlockLoader() {
  return (
    <div className="loader">
      <Loader size="md" />
    </div>
  );
}
